import React from "react";

/**
 * NJAS wordmark & mark — modeled on the actual email-signature identity:
 * sage-green + navy handshake mark, then bold condensed all-caps wordmark
 * "NOT JUST / A STATISTIC" with sage tagline "ELEVATE. EMPOWER. BELONG."
 */
export default function Logo({ variant = "full", tone = "dark", markSize = 44 }) {
  const ink = tone === "light" ? "var(--njas-bg)" : "var(--njas-navy)";
  const sub = tone === "light" ? "rgba(251,249,244,0.7)" : "var(--njas-sage-deep)";

  return (
    <div className="flex items-center gap-3" data-testid="site-logo">
      <Mark size={markSize} tone={tone} />
      {variant !== "mark" && (
        <div className="leading-[0.85]">
          <div className="njas-display text-[15px] sm:text-[17px]" style={{ color: ink, letterSpacing: 0 }}>
            NOT JUST
            <br />
            A STATISTIC
          </div>
          {variant === "full" && (
            <div className="njas-condensed mt-1.5 text-[9px] tracking-[0.24em] font-semibold" style={{ color: sub }}>
              ELEVATE · EMPOWER · BELONG
            </div>
          )}
        </div>
      )}
    </div>
  );
}

const HAND_LOGO_URL = "https://customer-assets.emergentagent.com/job_njas-justice/artifacts/apxezcqk_WhatsApp%20Image%202026-07-05%20at%2022.14.37.png";

export function Mark({ size = 40, tone = "dark" }) {
  // Official NJAS handshake artwork (transparent background PNG).
  // Works on both light and dark surfaces because the artwork itself
  // uses sage + navy fills which read cleanly on either.
  return (
    <img
      src={HAND_LOGO_URL}
      alt="NJAS handshake mark"
      width={size}
      height={size}
      style={{ width: size, height: size, objectFit: "contain", display: "block" }}
    />
  );
}
